export const formatStockPhotoTitle = (tags = '') => {
  if (typeof tags !== 'string') return '';

  return tags
    .split(',')
    .map((tag) => tag.trim())
    .filter(Boolean)
    .slice(0, 3)
    .map((tag) => tag.charAt(0).toUpperCase() + tag.slice(1))
    .join(', ')
    .slice(0, 500);
};
